module.exports = __webpack_public_path__ + "media/images/favicon/browserconfig-f6573953fda848d4cab0fb9ae1d006bf.xml";